// prettier-ignore
export default {
  generic: {
    network_error: '无法连接伺服器<br>请检查您的网路连线',
    network_restored: '网路连线已恢复',
    bluetooth_error: '蓝芽连线中断<br>扫描过程中请将您的装置靠近扫描机，并确保蓝芽讯号强度足够',
    permisson_device_orientation_not_allowed: '为了使用方向感应功能，建议您重新启动浏览器以重新询问权限。<br>或者确保手机与地面垂直90度后点击下一步。',
    permisson_device_orientation_not_support: '很抱歉，您的浏览器不支持方向感应功能。建议您尝试使用其他浏览器或设备。<br>或者确保手机与地面垂直90度后点击下一步。',
  },
  terms: {
    terms: "TG3D Studio Inc. Limited 及其关係企业（以下简称本公司）依据本服务条款（以下简称本条款）提供Cloudzet™自助式人体扫描及其相关服务（以下简称本服务）。<br><br>当您注册成为用户时，即视为您已阅读本条款并同意受其及相关法律之约束。当您使用本公司所提供服务及软体时，其附加条款或规定即成为您与本公司所订协议的一部分。若您为未成年人，除您本人应遵守本条款规定外，并应请您父母亲（或监护人）同时确实阅读、瞭解并同意遵守本条款之所有内容，您方得开始下载或使用服务与软体。 <br><br>当您于本条款为修改或变更后仍继续使用服务与软体时，即推定您或（及）您的父母亲（或监护人）已阅读、暸解、并同意本条款修改后之内容。<br><br>一、服务介绍 <br><br><br><br>本服务的Cloudzet™自助式人体扫描APP及自动扫描设备，可扫描用户之身体体型数据（扫描量体数据），并产生人体3D模型，（二者合称3D数据档案）。用户若于第三方商店使用本服务，第三方商店可使用用户之3D数据档案，以提供用户服装订製服务及（或）品牌服装推荐服务；本公司亦将透过本服务，推荐用户各式品牌服装。所有服装由第三方商店提供，用户向第三方订购服装应自行审视服装材质、尺寸、剪裁、订製、交件等相关讯息，以确保其购买权益。<br><br>二、定义 <br><br>1.软体：係指包括本公司及／或其关係企业所开发的Cloudzet™ App软体、所有的更新版本以及任何本公司以后所提供的辅助或附加应用程式或软体。 <br><br>2.用户：係指所有同意本条款内容，并完成用户注册程序的使用者。 <br><br>3.3D数据档案：透过本服务产出之人体三维数据档案，包含人体3D模型及扫瞄量体数据。 <br><br>4.人体3D模型：係指以3D形式显示之人体原始採集资讯。 <br><br>5.扫描量体数据：係指透过本服务所取得之用户身体可测量之围度与长度数据，包括但不限于颈围、胸围、腰围、臀围等。 <br><br>6.第三方商店：係指于本服务内可提供用户服装订製及（或）销售服务之厂商及其网站／APP。<br><br>三、用户帐号注册 <br><br>1.本服务得以手机号码、电子邮件为用户帐号。用户注册时应提供手机号码或电子邮件及注册流程中所要求之其他相关资料（如：姓名及性别）以完成各项认证，并使用本服务之所有功能。 <br><br>2.本服务亦得以微信或Facebook帐号密码登入本服务。<br><br>四、用户责任与义务 <br><br>1.真实资料义务 <br><br>您同意于注册时填写您正确、完整且符合真实之个人资料。您所登录之资料若事后有所变更时，可随时于线上更新。您所填写的个人资料如有不符合真实，或原填写之资料已不符合真实而未更新，或有任何误导之嫌，本公司拥有随时终止您用户资格及使用本服务之权利。如您提供资料为非本人或错误资讯，致第三方商店无法联繫或造成第三人权益之损害时，将自负相关法律及／或损害赔偿责任。<br><br>2.帐号保管义务 <br><br>a.用户帐号仅限用户本人使用，不得提供其他第三人使用。 <br><br>b.用户有义务妥善保管注册帐号、密码及其他相关资讯，以此组注册帐号登入系统后所进行之一切活动，均视为用户本人之行为。 <br><br>c.若用户发现注册帐号内个人资料遭他人非法使用或有任何异常使用之情形时，应立即通知本公司，并循适当法律途径保护自身权益；必要时，本公司会请用户提供相关个人资料，并有权未经通知而暂停该争议帐户之使用权限。 <br><br>d.如因用户保管疏忽或同意由第三人使用其帐号，导致用户帐号、密码遭他人非法使用，造成本公司或其他用户权益损害时，将自行负责相关法律及／或损害赔偿责任。<br><br>五、人体3D数据之蒐集 <br><br>当您注册或是使用本服务时，即代表您同意本公司为提供TG3DsCloudzet™自助式人体扫描本服务而蒐集您的扫描量体数据以及人体3D模型。<br><br>六、软体授权及限制 <br><br>1. 本公司授权您使用软体，但您必须确实遵守本条款及各项软体及服务之附加条款，如有任何违反情形，经本公司察觉后，可不经通知迳行中止或终止您使用软体的权利。 <br><br>2. 本公司授权您使用软体进行自助式人体扫描服务及其他本公司相继开发之服务，但您不得更改、再授权、出租、销售、或以任何非本条款授权之方式使用软体。您并同意遵守所有相关法令，即只为合法目的而使用软体。 <br><br>3. 本公司仅授权您使用软体，所有软体及相关编码程式之智慧财产权仍属本公司所有。用户不可对软体进行任何修改、还原工程、反向编码、简化为常人可理解形式或反向组译、阻止或妨碍其他用户享受软体与服务、藉软体与服务而散播病毒或其他足以损害他人电脑运作之程式、违反本条款的软体或内容、及任何可能侵害他人智慧财产权或其它权益之内容。 <br><br>4. 本公司得採取任何必要的手段，防止您以本条款或相关法令所禁止的方式使用软体与服务。<br><br>七、隐私权政策<br><br>相关隐私权说明，请参考隐私权政策。<br><br>八、智慧财产权 <br><br>1.本公司仅授权您使用服务及软体，而并非将本公司所提供的服务、软体及任何编码的着作权移转给您。为免存疑，一切本公司没有在本条款中明确授予您的权利，均由本公司保留。 <br><br>2.您承认本公司之服务、内容、软体及技术受各授权地区相关法令保护，并同意不会移除或变更服务及软体中所包含的任何着作权权利电子管理资讯、防盗拷措施或其它权利（包括且不限于专利权、商标权）或软体的标记。<br><br>九、责任限制 <br><br>1.本公司对于透过软体与服务而提供的任何资讯、内容、软体或服务，均仅依各该服务当时之功能及现况提供使用。就连线中断、延迟或与通讯相关缺陷，本公司对服务形式或内容不负任何担保或保证责任。 <br><br>2.除法律明文禁止外，在任何情况下，本公司不对任何损失负损害赔偿的责任，包括因使用或无法使用软体或服务而引起的损失，或其它直接、间接、意外、特别或因应性的损失(包括但不限于生意盈利的损害或遗失、生意中断、生意资讯的遗失、和任何其它金钱上的损失)。 <br><br>3.本公司对于用户因第三方商店及其他用户或其他使用者的故意或过失所造成的任何瑕疵与损害，不负担保与赔偿之责。 <br><br>4.用户使用本服务时，如与第三方商店或品牌服饰厂商之交易发生纠纷时，本公司不负任何担保或赔偿责任。<br><br>十、使用条款修改 <br><br>本公司保留随时修改本条款的权利。当本公司将修改后的用户使用条款内容于本公司网站上公布以后，您继续使用本软体与服务的行为即代表您已接受此修改。<br><br>十一、准据法与管辖法院 <br><br>1.本条款之解释、补充及适用均以中华民国法令为准据法。如有未尽事宜，请联繫本公司。 <br><br>2.倘本条款之中文版与英文版有差异时，以中文版为准。您与本公司双方都同意所有因本条款所产生的争议若无法协调解决而需诉讼时，都以台湾台北地方法院 为第一审的管辖法院。",
    privacy: "TG3D Studio Inc. Limited 及其关係企业 （以下简称本公司）重视用户的个人隐私，并遵循保护隐私权及个人资料之相关法令规定。以下是本公司之隐私权政策（以下称「本政策」），将说明本公司会收集哪些个人资料与如何使用这些资料，并说明其他与您的隐私相关的重要事项。<br><br>1.当您注册成为Cloudzet™ 自助式人体扫描服务之用户时，会要求您输入注册帐号（手机号码或电子邮件信箱）、姓名、性别以及生日。<br><br>2.当您透过微信或 FACEBOOK 帐户（以下简称「第三方网站」）注册成为本服务用户时，您同意本公司蒐集您的身分验证资料以及在您的第三方网站帐号上可以看到或透过您的第三方网站帐号可以找到的其他资料，包括您的姓名、个人资料图片、国家、电子邮箱地址、出生日期、性别、朋友的姓名及其个人资料图片和交友网络等。本公司可能需要验证您的资料是否与该第三方网站上的资料一致及/或依照本政策利用该等资料。<br><br>3.当您在使用本服务时，本公司可能会蒐集下列资讯： <br><br>(1)您的扫描量体数据及人体3D模型，以及身高、体重以及地址。 <br><br>(2)您的使用资料，包括但不限于相机、相片、SD卡内容 等； <br><br>(3)技术数据，例如：URL、IP 地址、浏览器类型、作业系统资料、语言及造访时间等。本网站及软体将会透过Google Analytics分析工具来蒐集前述资料，相关Google Analytics(分析)隐私权政策与如何拒绝向Google Analytics(分析)透露资讯，您可直接前往Google Analytics(分析)资料隐私权与安全性网页浏览进行瞭解。若您不愿意向Google Analytics(分析)透露资讯，您可以下载Google Analytics (分析) 不透露资讯浏览器外挂程式。<br><br>4.本公司为提供您正确与快速的服务，当您使用本服务时，如: 商品订购、帐户异动、意见回馈或参与产品行销活动，会请您提供用户帐号资料或个人联繫方式。<br><br>5.本公司蒐集到的资讯，将用于以下用途： <br><br>(1)您所提供的基本个人资料（如姓名），将作为本公司或第三方商店作为用户身分判定的依据；您所提供的联繫方式，将作为本公司或第三方商店用以联络、行销活动通知、通知缴费、活动中奖通知、扣款通知、寄送发票、提供个人化品牌服饰推荐、或其他与本服务相关更新通知。 如果您不想收到任何行销简讯或是电子邮件，请联繫 support@tg3ds.com。<br><br>(2)您的3D数据数据，将作为第三方商店为您订製服装或建议成衣尺寸之用，或由本公司推荐各品牌成衣。 <br><br>(3)您因使用本服务所产生之资讯，包含3D数据档案、使用资料及技术资料等，将作为改进本服务或开发新服务用。<br><br>(4)我们将以推播的方式提供您我方及任何第三方之行销资讯及广告。若您不愿意再收到此类的推播讯息，或是原本于注册时您虽同意本服务可接触您的相机、相片及SD卡之资料，但嗣后决定欲停止此利用，您可透过您的装置本身之功能设定停止前述使用。<br><br>6.您明白且同意本公司可能与第三方共用综合性的非个人资料。综合性非个人资料是指记录有关用户的资料已经过分类或编辑后不再反映或指向某个特定的可被辨识的使用者之资料。<br><br>7.上述资讯之处理与利用，可能由本公司之关係企业或其他合作伙伴进行，或于台湾外发生。除非有当地法律除外情况，本公司不会将这些资讯用做其他用途。本公司亦不会未经用户事先同意向第三者透露其个人资料，但因国家重大利益或为配合执法机关调查而根据法律而需要透露者则除外。<br><br>8.您本人可查询、複製或申请变动属于您个人资料范围，若非本人或于本公司尚未查证您为本人前，您不得申请查询、複製、请求阅览或申请变动不属于本帐号之个人资料及帐号服务。如非前述情况之申请者，必要时您将提供相关个人资料及书面资讯，使本公司可协助处理作业程序。<br><br>9.您本人可要求停止利用或删除属于您的个人资料；但一经停止或删除，您将无法继续使用 本服务，并可能影响您与第三方商店之交易。<br><br>10.即使您要求删除属于您的个人资料，您不可撤回地同意本公司仍得保留综合性之个人资料，以改进本服务及相关技术或开发新服务用。<br><br>11.于妨害国家重大利益、妨害公务机关执行法定职务、妨害蒐集机关或第三人重大利益时，本公司有权拒绝您主动提出变更、删除或异动个人资料之请求。<br><br>12.为保护您的隐私，本公司提供必要之技术及措施保护个人资料。<br><br>13.您的个人资料、注册帐号及密码等，请您妥善保管，避免外洩。于个人或非个人电脑上使用本服务时，必要时请登出或关闭软体与浏览器视窗，以免您的资料遭人盗用。<br><br>14.您的付费资讯(含信用卡资料)，请您妥善保管，避免为他人之不法用途。<br><br>15.本服务均有可能包含其他非本公司网站或网页连结，若您个人同意该网站蒐集、处理或利用您的个人资料，本公司不负任何连带责任。<br><br>16.您同意在本服务进行之消费时所留存的资料与事实相符，如嗣后发现你的个人资料遭他人非法使用或有任何异常时，应即时通知本公司。<br><br>17.您同意于使用本服务时，所提供及使用之资料皆为合法，并无侵害第三人权利、违反第三方协议或涉及任何违法行为。如因使用服务而致第三人损害，除本公司故意或重大过失外，本公司并不负担相关赔偿责任。<br><br>18.本公司将不定时更新本政策，并遵循当地隐私权与个人资料保护相关法令，当本公司做出重大修改时，会于官方网站 (http://www.tg3ds.com) 或APP公布。<br><br>19.本政策构成服务条款的一部分。如您不同意本政策之任何条款或修改变更之内容，请您立即停止使用服务。<br><br>20.如果您对本公司的隐私权或个人资料保护政策有任何问题，请联络 suppot@tg3ds.com",
  },
  login: {
    cloudzet_welcome: '嗨！ 欢迎来到云衣适',
    mtm_username: 'Scanatic™ 帐号',
    password: '密码',
    login: '登入',
    logging_in: '登入中',
    no_login_methods: '无法使用此 Scanatic™ 帐号登入',
    agreements_button: '同意并继续',
    complete_email_reset_pwd_title: `交给我们！`,
    sent_email: `我们已发送密码变更认证信至`,
    email_reset_pwd: '请按照邮件中的指示，即可重设密码',
    get_the_code: '没有收到认证码？',
    resend: '重新发送',
    complete_phone_reset_pwd_title: '恭喜您！',
    login_new_password: '您已成功设置了新密码，请使用新设置的密码登入帐号',
    login_my_account: '登入帐号',
    sent_a_code: '我们已发送认证码至',
    received_code: '是否有收到？',
    verification_code_error: '认证码有误',
    continue: '继续',
    forget_your_password: '忘记密码？',
    forget_password_text: `别担心！`,
    send: '发送',
    submit: '送出',
    no_such_user: '查无帐号',
    email_prompt_text: `我们会将密码更变认证信发送至您的信箱`,
    phone_prompt_text: `我们会将四位数的认证码发送至您的手机`,
    login_title: '欢迎回来！',
    login_email_title: '使用电子邮箱登入',
    login_phone_title: '使用手机号码登入',
    forget_password: '忘记密码？',
    terms_of_service: '服务条款',
    choose_a_country_code: '选择国家区域码',
    choose_a_country_code_hint: '登入/注册仅限以下国家或地区',
    country_code_not_found: '找不到您的国家区域码？',
    sign_up_email: '使用电子邮箱注册',
    email_sign_up_error_msg: '请输入正确的电子邮箱',
    four_characters: '您的密码必须至少要有四个字元',
    try_to_login: '此帐号已被注册，请选择直接登入',
    try_use_email: '尝试使用您的电子邮件',
    sign_up: '注册',
    sent_verification_code: '我们会将四位数的认证码发送至您的手机',
    sign_up_phone: '使用电话号码注册',
    sign_up_store: '使用店家注册',
    set_up_new_pwd: '请设置您的密码',
    set_up_new_password: '请设置您的密码',
    set_new_pwd: '设置新的密码',
    enter_country_code: '输入国家区域码',
    enter_email_address: '输入您的电子邮件',
    enter_phone_number: '输入您的电话号码',
    customer_account_name: '客户帐号名称',
    enter_password: '输入密码',
    re_enter_password: '重新输入密码',
    login_social_accounts: '使用社群帐号注册',
    social_login_failed: '使用社群帐号登入失败',
    login_first: '请先登入',
    create_with_store: '店家建立',
    verify: '确认',
    welcome_to_store: '欢迎来到 {storeName}！',
    login_to_continue: '登入/ 注册以继续',
    wrong_password: '密码错误，请确认密码',
  },
  stamp: {
    tap_to_start: 'スキャン開始手順を読み<br>準備ができたら、タップしてください',
    tap_camera_on: '指でタップしてカメラを起動',
    welcome_title: 'Welcome to<br>STAMP SCAN BOX',
    note_front_camera: 'あなたのスマートフォンを使ってLINE上からSCAN CODEを起動し、前面のカメラにかざしてログインしましょう',
    scan_code_title: '',
    scan_code_hint: 'SCAN CODEを枠内にかざしてください',
    things_to_note_title: 'Before The 3D Body Scan',
    clothes_info: '肌に密着した下着のみになってください<br>衣類はボックスに入れてください',
    clothes_alt_info: '男性のトランクス、女性のブラトップなど、ゆとりのありすぎる衣類では、正常にスキャンできない場合があります',
    accessories_info: 'メガネ以外のアクセサリー類は外してください<br>髪の長い方は首にかからないように結んでください',
    accessories_alt_info: 'ヘアゴムはボックス内に、用意しています',
    touch_for_tutorial: 'スキャンの準備ができたら指でタップ',
    tutorial: {
      title: 'The Contactless Control Tutorial',
      contactless: '3Dスキャンの操作ガイドを始めます',
      clench_fingers: '両手は軽く握り、握り拳を作ります',
      raise_arm: 'マークの位置まで両腕をあげます',
      raise_arm_2: 'マークの位置でセンサーが反応し、スキャンが始まります',
      feet_pos: '足型に合わせて気を付けの姿勢で立ちます',
    },
    choose_to_start: {
      title: '3D Scan Tutorial',
      start: 'マークの位置まで両腕をあげてください',
      done: 'この体制でスキャンが始まります',
    },
    end_goodjob: 'おつかれさまでした',
    end_line: 'LINEスキャンメニューからカメラを起動し、<br>QRコードを読み取ってチェックアウトしましょう',
    choose_step_info: 'マークの位置まで右腕をあげてください',
    clench: '両手は軽く握り、握り拳を作ってください',
    feet_position: '足型に合わせて気を付けの姿勢で立ってください',
    raise_arm: 'マークの位置まで両腕をあげてください',
    hold_left: '左腕を、マークの位置までゆっくりあげてください',
    hold_right: '右腕を、マークの位置までゆっくりあげてください',
    scan_step_name_begin: 'Begin the 3D Body Scan',
    scan_step_name: '3D Body Scan',
    scan_step_name_2: '2nd Time 3D Body Scan',
    scan_body_start: 'マークの位置まで両腕をあげてください',
    scan_in_progress: 'スキャンが始まります<br>そのまま動かないでください',
    scan_complete_1: '1回目のスキャンに成功しました。<br>腕を降ろして、リラックスして下さい',
    scan_complete_2: '2回目のスキャンに成功しました。<br>腕を降ろして、リラックスして下さい',
    analyzing: '3Dデータを生成しています',
    leave: 'ログアウト',
    end_next: 'スキャンを終了する',
    end_next_info: 'Next Information',
    end_instruction: '洋服を着て下さい。<br> 続けて、外のタブレットへと移動し、<br> 新たな体験をお楽しみください。',
    scan_again: 'もう一度スキャン',
    scan_unsuccessful: 'スキャンに失敗しました',
    scan_successful: 'スキャンデータの生成に成功しました',
    neck: '首回り',
    chest: 'チェスト',
    chest_female: 'バスト',
    torso: '胴回り',
    mid_waist: 'ウエスト',
    hip: 'ヒップ',
    shoulder: '肩幅',
    biceps: '上腕回り',
    arm: '腕丈',
    thigh: '太もも',
    inner_leg: '股下-地面',
    avoid_errors: 'スキャン時の注意事項を確認してもう一度スキャンしてください',
    error_accessories: 'メガネ以外のアクセサリー類を外してください',
    error_cover_neck: '髪の長い方は首が隠れないよう結んでください',
    error_floor_marks: '足型に合わせて立ってください',
    error_postural: 'スキャン時は姿勢を正してください',
    welcome_steps: 'スキャン開始手順',
    welcome_step_1: '靴と鞄はボックスに入れてください',
    welcome_step_2: 'LINE下部メニューのスキャンコードをタップしQRコードを発行します',
  },
  hm: {
    end_title: 'Thank you!',
    end_text: 'You can now return to the Body Scan Jeans Design Station to customize your jeans.<br>Remember to carry your personal belongings with you.',
  },
  welcome: {
    enable_bt: '开始前，请记得开启您的蓝芽',
    welcome_title: '欢迎来到 3D 扫描室',
    powered_by: 'Powered by TG3D Studio Inc.',
    tap_to_start: '点击按钮开始 3D 扫描',
    tap_camera_on: '开启相机镜头扫描二维码',
    ready_to_scan_qr: '扫描二维码',
    note_front_camera: '注意：您在扫描二维码时，前镜头将会被开启',
    scan_code_title: '扫描二维码并进入扫描流程',
    scan_code_hint: '请将二维码放入方框中',
    scan_code_processing: '处理中',
    scan_code_logging_in: '帐号登入中',
    scan_code_connect_to_scanner: '扫描机连线中',
    scan_code_no_account: '此帐号不存在，请重新尝试',
    scan_code_done: '准备开始',
    no_scanner_id: '此 Scanatic™ 帐号并没有扫描机连结设定',
    no_scanner_found: '搜寻不到扫描机',
    scanner_in_use: '扫描机使用中',
    unexpected_error: '抱歉！出了点问题，请稍后再试',
    need_camera_permission: '您必须同意给予使用相机的权限才能进行此操作',
    share_qr_code: '分享我的二维码',
    my_qr_code: '我的二维码',
    scan_qr_code_reminder: '扫描二维码以在其他装置上登入',
  },
  choose: {
    step_name: '准备好 3D 扫描了吗？',
    step_info: '准备好后，将手臂举起，把拳头放进两旁的泡泡框中',
    tutorial: '扫描教学',
    start_scan: '3D 扫描',
    clench_fingers: '双手轻握拳',
    raise_arm: '将手臂举起至拳头触碰到泡泡框',
    hold_til_fill: '停在这个位置，直到泡泡框填满',
  },
  thingstonote: {
    title: '开始扫描之前',
    wear_tight: '穿着贴身衣物',
    tie_hair: '束起长发，露出脖子',
    remove_acc: '移除首饰配件',
  },
  scanscreen: {
    skip: '略过说明',
  },
  tutorial: {
    title: 'The Contactless Control Tutorial',
    contactless: 'The contactless experience ensures your health is protected',
    clench_fingers: 'Lightly clench your fingers',
    raise_arm: 'To control the bubbles, please raise your arms until you touch the bubbles and hold for 2 seconds',
    hold: 'Now hold until the bubble is filled',
    proceed: 'To proceed to the next step, raise your right arm until it touches the bubble.',
    return: 'To return to the previous step, raise your left arm until it touches the bubble.',
    feet_pos: 'Position your feet on the floor mat',
  },
  scan: {
    feet_pos: '脚踩定位',
    step_name: '3D 人体扫描',
    phase_one_done: '第一阶段扫描完成',
    begin_2nd: '开始第二阶段 3D 人体扫描',
    clench: '双手轻握拳',
    raise_both_arm: '将手臂举起至拳头触碰到泡泡框',
    raise_fists: '位置过低。将您的双臂继续张开，直到拳头完整放入泡泡框中',
    lower_fists: '位置过高。将您的双臂降下，让拳头完整放入泡泡框中',
    hold_still: '请保持手臂静止不动',
    scan_keep_still: '请保持身体静止不动',
    scan_in_progress: '扫描中',
    scan_complete: '扫描完成，请放松身体',
    two_step_scan: '扫描将分成两阶段进行',
    scanner_occupied: '扫描室被占用，请联系服务人员',
    scanner_error_need_reset: '扫描机出现问题，请联系服务人员重启扫描机后再重试',
    scanner_error_generic: '扫描机出现问题，请联系服务人员',
    scanner_not_activated: '扫描室未上线，请激活后再进行扫描测试',
    scanner_check_network: '扫描机无回应，请稍后再试',
  },
  handles: {
    hold: '双手轻握手把<br>双臂放松伸直',
    hold_ready: '双手轻握手把<br>准备扫描',
    letgo_and_keep_feet: '松开手把，保持原本站姿<br>直视前方',
    clench_ipose: '双手轻握拳<br>平行两侧约5公分',
    clench_ready: '双手轻握拳<br>准备扫描',
  },
  end: {
    thank: '谢谢！',
    belonging: '请穿回衣服并记得带走您携带的物品',
  },
  analyzing: {
    check_err: '3D 化身建立中...',
  },
  result: {
    scan_successful: '太好了！您的 3D 扫描结果十分成功！',
    scan_unsuccessful: '糟糕！我们无法处理您的3D扫描数据',
    avoid_errors: '扫描常见错误',
    error_accessories: '戴着手饰项链等配件',
    error_cover_neck: '头发盖住脖子',
    error_floor_marks: '双脚未站定位',
    error_postural: '姿势错误',
    leave: '离开',
    raise: '若想重新扫描，请将手臂举起至拳头触碰到泡泡框',
    scan_again: '重新扫描',
    analyzing: '扫描资料处理中...',
    click_scan_again: '请按下方按钮再次扫描',
    oops: '糟糕!',
    unexpected_error: '发生了未知的错误...',
    close: '关闭',
  },
  measurement: {
    neck: '颈围',
    chest: '胸围',
    torso: '身长',
    mid_waist: '腰围',
    hip: '臀围',
    shoulder: '肩宽',
    biceps: '臂围',
    arm: '臂长',
    thigh: '大腿围',
    inner_leg: '内腿长',
    chest_female: '胸围',
  },
  homePage: {
    firstScanTitle: '开创未来无限可能',
    tap_to_scan: '点击按钮进行 3D 扫描',
    measurement: '尺寸',
    body_3d_avatar: '3D 人体',
    see_more: '查看更多',
    menu: '主选单',
    store_settings: '商家设定',
    avatar_shader_3d: '3D 人体材质',
    avatar_shader: '人体材质',
    create_3d_shader: '制作 3D 材质',
    language: '语言',
    get_help: '获取帮助',
    feedback: '回馈',
    send_feedback: '提供回馈',
    send_btn: '送出',
    send_feedback_placeholder: '您的回馈将会帮助我们优化产品及服务',
    send_feedback_title: '感谢您的意见与回馈',
    send_feedback_content: '我们已将您的意见及回馈记录下来，您的宝贵建议是我们持续优化产品服务的最大动力，期待未来能够带给您更优质的产品体验。若有更多的回馈意见，请随时与我们联系。',
    report_crash: '回报问题',
    report_crash_title: '感谢您的回报',
    report_crash_content: '很抱歉造成您在体验上的不愉快，我们的开发团队会尽快调查问题原因，并尝试解决。如果您还有遭遇到其他的问题，请随时与我们联系。',
    rate_app: '我爱云衣适',
    rate_app_title: '在 App Store 评价云衣适',
    rate_app_content: '若您对于此次的体验十分满意，请别吝啬于 App Store 中给予云衣适五颗星，谢谢您！',
    login_s4f: '使用 Scanatic™ 帐号登入',
    login: '登入',
    password: '密码',
    account_settings: '帐号设定',
    enter_Scanatic_account: '输入 Scanatic™ 帐号',
    logout: '登出',
    delete_account: '删除帐号',
    confirm_delete: '您确定吗？',
    contactless_scan: '免触式感应扫描',
    delete: '删除',
    cancel_delete: '取消',
    ok: '确定',
    scan_to_login: '扫码登入',
    history: '扫描记录',
    view_avatar: '查看扫描记录',
    analysis: '分析',
    comparison: '比較',
  },
  settingUserData: {
    your_birth: '请问您的出生年份',
    your_gender: '请问您的性别',
    female: '女',
    male: '男',
    tall: '请问您的身高',
    cm: '公分',
    ft: '英呎',
    inch: '英吋',
    your_height: '身高',
    your_weight: '请问您的体重',
    weight: '体重',
    lbs: '磅',
    kg: '公斤',
    nickname: '您的姓名',
  },
  profile: {
    profile: '个人信息',
    edit_profile: '编辑个人资料',
    name: '姓名',
    birthday: '生日',
    birthyear: '出生年',
    phone: '电话号码',
    address: '地址',
    email: '电子邮箱',
    save: '确定',
  },
  discover: {
    head_title: '探索更多',
    check_my_size: '查看我的尺码',
    rmd_size: '推荐尺码',
    no_rmd_data: '没有适合您的尺码',
    no_rmd_items: '哎呀！目前无推荐的单品',
    buy_item: '购买',
  },
  discovery: {
    turn_on_bt: '开启蓝芽',
    turn_on_bt_hint: '请授权并启用蓝牙',
    turn_on_bt_hint_ios: '请确保以下设定皆有完成：<br>1. 授权权限<br>　　● 前往「设定 > 隐私与安全性 > 蓝牙」，开启「云衣适」权限<br>2. 启用蓝牙<br>　　● 前往「设定 > 蓝牙」，切换开关至「开启」',
    turn_on_bt_hint_android: '请确保以下设定皆有完成：<br>1. 启用蓝牙<br>　● 从萤幕顶端向下滑动，轻触「蓝牙」图示',
    searching: '扫描机搜寻中...',
    select_scanner: '请选择您所在的扫描室开始进行扫描',
    scanner__foot: '足部扫描机',
    scanner__body: '人体扫描机',
    start_scan: '开始 3D 扫描',
    no_scanners: "附近没有侦测到任何扫描机",
    try_again: '再试一次',
    scanner_is_busy_title: '扫描机使用中',
    scanner_is_busy_desc: '请确认里面是否有人正在使用扫描机。',
    scanner_is_busy_force_release: '立即扫描',
    scanner_is_busy_wait: '等待扫描完毕',
  },
  footscan: {
    take_off: '开始足部扫描，请先脱掉您的鞋子',
    barefoot: '脱掉袜子或是穿着合脚的袜子',
    show_ankles: '卷起裤管，露出您的脚踝',
    sit: '请坐在椅子上，膝盖保持90度弯曲',
    stand_up: '请起立',
    position_feet: '请将双脚踩定地上的标示',
    start_scan: '开始扫描',
    ready_to_scan: '准备好了!',
    stand_up_for_2nd_scan: '请起立并保持自然站姿，双眼平视前方，进行扫描',
    stand_still: '保持自然站姿，双眼平视前方',
    scan_complete: '扫描完成<br> 请放松身体',
    creating_3d_foot: '3Ｄ模型建立中...',
    scan_successful: '太好了！您的 3D 扫描结果十分成功！',
    click_to_rescan: '按下按钮重新扫描',
    feet_3d: '3D 足部扫描',
    analysis: '足部分析',
    initial_l: '左',
    initial_r: '右',
    tab__fit: '鞋码',
    tab__width: '足宽',
    tab__arches: '足弓',
    tab__measure: '尺寸',
    tab__type: '脚型',
    shoes_guide: '鞋子尺寸建议',
    shoes_last: '你的楦宽',
    measurement__ball: '脚掌围',
    measurement__foot_length: '足长',
    measurement__foot_width: '足宽',
    measurement__instep: '脚背围',
    measurement__span: '脚腰围',
    measurement__arch: '足弓',
    measurement__finger_shape: '脚型',
    arch_type__title: '你的足弓高度',
    arch_type__high: '高足弓',
    arch_type__summary_high: '- 中足部分空凹较多，足底压力集中在前脚掌与脚跟，脚部缓冲能力相对较弱，足弓无法为踏地时提供足够的张力，容易外旋、稳定度不佳<br>' +
      '- 因脚掌接触地面的范围减少，较易长茧、疼痛，脚底韧带紧绷及鞋跟外侧严重磨损',
    arch_type__desc_high: '- 先天遗传性的足底肌肉挛缩<br>' +
      '- 长期穿着过小、过紧或过窄的鞋子<br>' +
      '- 长时间穿着高跟鞋，造成重心前倾、脚跟不稳定、脚趾不易伸展、足背拱起<br>' +
      '<br>' +
      '保养与自疗：<br>' +
      '- 若足底长期受力不均，容易引发足底筋膜炎<br>' +
      '- 足底筋膜伸展、按摩<br>' +
      '- 小腿肌肉伸展<br>' +
      '<br>' +
      '鞋款建议：<br>' +
      '吸震能力为首要考量，适合高缓冲、高避震性的鞋款及鞋垫<br>' +
      '鞋底硬度约在45度左右为佳，不宜太薄或太硬<br>' +
      '利用高足弓鞋垫有效支撑足弓，平均分散足底压力，减少腿部冲击',
    arch_type__normal: '正常足弓',
    arch_type__summary_normal: '恭喜你！你的足弓非常标准！',
    arch_type__desc_normal: '完美的足弓<br>' +
      '<br>' +
      '保养与自疗：<br>' +
      '- 保持正常运动及体重<br>' +
      '<br>' +
      '鞋款建议：<br>' +
      '- 正常足弓的足底压力受力均衡，可依照自己的需求和脚楦宽度等选择适合自己的鞋型 <br>' +
      '可选择一般稳定支撑及缓冲性佳的鞋款',
    arch_type__low: '低足弓',
    arch_type__summary_low: '- 足弓不明显，脚掌接触地面范围较大，在踏地时内纵足弓消失，负荷会由内部边缘承担，而非前脚掌，导致足部不稳，鞋的内侧较快磨损。 <br>' +
      '- 久站或久走容易脚酸<br>' +
      '- 走路或跑步时较容易跌倒',
    arch_type__desc_low: '- 先天遗传性的韧带松弛、膝外翻、股骨前倾变形等现象<br>' +
      '- 足部外伤、骨折或类风湿性关节炎、足关节炎等后天性疾病<br>' +
      '- 体重过重加上穿鞋习惯姿势错误造成<br>' +
      '<br>' +
      '保养与自疗：<br>' +
      '- 足部肌力强化训练，如垫脚尖、跳绳、走直线、脚趾抓毛巾等<br>' +
      '- 保持正常体重，避免增加双脚负担<br>' +
      '<br>' +
      '鞋款建议：<br>' +
      '- 穿着高支撑性足弓垫或鞋款，承托与固定足弓形状，改善足弓下塌及防止足踝外翻<br>' +
      '- 适合宽鞋头使脚掌有足够的空间生长活动，后跟必须有坚挺的包覆，且鞋底要坚实、不宜太软太硬<br>' +
      '- 扁平足的步态因内旋力量过大，容易造成小腿肌肉疲劳，因此在选鞋不能太软 ，以免造成稳定度不佳引起足部疼痛，硬度约 40~60 度左右为佳',
    foot_type__title: '你的脚型',
    foot_type__egyptian: '埃及脚',
    foot_type__summary_egyptian: '大拇趾最长，其他四趾依序变短',
    foot_type__desc_egyptian: '埃及脚为最常见的脚型，因为脚趾依序排列俗称 : 百搭脚型; <br>' +
      '非常适合穿圆头鞋或斜头鞋。 <br>' +
      '但不适合穿着尖头鞋，因最长的大拇趾容易受尖头鞋的压迫，造成拇指外翻<br>' +
      '<br>' +
      '鞋款建议：<br>' +
      '圆头鞋、斜头鞋',
    foot_type__roman: '罗马脚',
    foot_type__summary_roman: '前三趾齐长，另外两趾较短',
    foot_type__desc_roman: '- 极少数人拥有的脚型，也被称作为芭蕾舞而生的脚型。 <br>' +
      '- 罗马脚外型呈现较方正，可选择楦头较宽的版型，如方头鞋或圆头鞋，避免挤脚。 <br>' +
      '- 另外也可以选择材质较软的鞋款，减少脚趾被束缚的不适。 <br>' +
      '<br>' +
      '鞋款建议：<br>' +
      '方头鞋、圆头鞋',
    foot_type__greek: '希腊脚',
    foot_type__summary_greek: '第二趾最长，脚板瘦长',
    foot_type__desc_greek: '- 拥有希腊脚型的人通常四肢修长，据说许多美女都符合希腊脚的特征，有趣的是，纽约自由女神、希腊诸神雕像都是这种脚型。 <br>' +
      '- 因前脚掌重心会集中在最细长的第二趾，非厚肥的大拇指，因此建议选择有前掌海绵、弹力支撑的鞋款<br>' +
      '- 希腊脚的脚型是最能完美贴合尖头鞋、高跟鞋鞋头空间，因此最适合穿着尖头鞋或高跟鞋<br>' +
      '<br>' +
      '鞋款建议：<br>' +
      '尖头鞋、高跟鞋',
    foot_type__unknown: '未知',
    foot_type__summary_unknown: '未知',
    foot_type__desc_unknown: '未知',
  },
  mobileScan: {
    mobile_scan: '手机扫描',
    body_scanner: '人体扫描机',
    data_processing: '扫描资料处理中...',
    comeback_later: '稍候 5-10 分钟再回来检查您的 3D 模型',
    data_process_failed: '扫描失败',
    error_not_inscreen: '你的全身从头到脚没有完整的出现在画面中',
    error_messy_background: '背景太杂乱',
    device_unsupported: '糟糕！ <br>您的设备目前并不支援3D 手机扫描功能',
    need_faceid: '目前 3D 手机扫描只适用于 iPhone X 或更新款具有Face ID功能的机型',
    scanner_name: '3D 手机扫描',
    confirm_info: '请确认您的个人资料',
    begin_title: '准备开始',
    begin_info: '请穿着贴身衣物<br>束起长发，露出脖子',
    start_tutorial: '开始教学',
    not_first: '已经操作过手机扫描了？',
    skip_tutorial: '跳过教学',
    vertical_info: '将手机<br>以 90° 的角度<br>直立于平面',
    inscreen_info: '确保全身<br>从头到脚都完整的<br>出现在画面中',
    backoff_info: '按下一步后，<br>请在 10 秒内<br>回到原位',
    spin_info: '扫描时，请将双手握拳、<br>手臂张开，并在十秒内<br>原地360度的旋转一圈',
    check_title: '准备开始扫描',
    check_info: '请检查并勾选是否符合下列指示',
    wear_tight: '请穿着贴身衣物、<br>束起长发并露出脖子',
    wipe_front: '请擦拭前镜头',
    volume_up: '调高手机音量',
    next: '下一步',
    start_scan: '开始扫描',
    starting_in: '即将开始',
    preview_info: '请检查你的扫描数据是否符合下列指示并勾选确认',
    preview_inscreen: '全身入镜于画面中',
    preview_arms_open: '手臂张开',
    preview_spin: '原地旋转 360°',
    rescan: '重新扫描',
    uploading: '扫描数据处理中...<br>请勿关闭视窗',
    uploading_done: '分析完成！<br>请稍候 5-10 分钟再回来检查您的 3D 人体模型',
    finish_btn: '完成',
    upload_error: '店家的人体扫描功能尚未开启，请联系店家服务人员',
    no_balance: '店家人体扫描功能已暂停，请联系店家服务人员',
    scan_limit_reached: '您已超过店家设定的本月扫描次数',
    leave: '离开',
    no_credits: '您没有足够的手机扫描点数',
    no_email: "您还没有填写Email",
    credits: '手机扫描点数',
    purchase: '购买点数',
    purchase_cart: '我的购物车',
    purchase_total: '总计',
    purchase_item: '项目',
    purchase_checkout: '结帐',
    purchase_reminder: '我们将会寄送付款收据至您的电子邮件信箱。',
    payment_succeed: '恭喜! \n您的订单已成立',
    payment_succeed_des: '我们将会寄送信件至您的电子邮件信箱，\n请至您的电子信箱确认订单详细内容',
    update_email: '填写 Email'
  },
  mobileScan2: {
    inscreen_front_info: '拍正面照<br>请确认全身入镜<br>双手双脚微微张开',
    inscreen_side_info: '拍侧面照<br>请原地向左转<br>双脚并拢双手贴紧大腿外侧',
    inscreen_info: '确认全身完整显示在画面之中',
    trun_left_info: '请向左转，双脚并拢，双手贴紧大腿外侧',
  },
  share: {
    voucher_expired: '连接过期，请重新启动页面',
    no_scan_data: '尚未有扫描数据',
  },
};
